export function decode(jwt: string): JWT {
    const payload = jwt.split('.')[1];

    return JSON.parse(fromBinary(payload));
}

// Source: https://stackoverflow.com/a/30106551
// Decoding base64 ⇢ UTF-8
function fromBinary(str: string): string {
    const sanitizedString = str.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(
        atob(sanitizedString)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );
}

export interface JWT {
    userId: string;
    name: string;
    firstName: string;
    lastName: string;
    admin: boolean;
    owner: boolean;
    accountManager: boolean;
    accountId?: string;
    language: string;
}
